import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/wechat';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async fans(params: any) {
    return api.fans(params);
  }
}
